import React from "react";
import { useTranslation } from "react-i18next";
import { CheckboxIcon, CrossIcon } from "@aureskonnect/react-ui";
import { AvForm } from "availity-reactstrap-validation";
import { Modal } from "reactstrap";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { mutate } from "swr";

import { fetchGlobal } from "../../../../api/hooks";
import { store } from "@components/VerticalLayout/store";
import { setIsEdited, setIsLoading, setShopDataIsUpdated } from "../store";

import {
    CustomCardFooter,
    CustomCardHeader,
} from "../../../../components/Common/CustomCardStyled";
import { capitalize } from "../../../../helpers/general";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import { ThirdPartyConfigureType } from "../Types";
import { CreateOrganizationBody } from "./CreateOrganizationBody";
import { store as thirdPartyStore } from "../store";
import { CreateDataThirdParty } from "../helper";
import { emailMatchWord } from "@constants/index";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { useSelector } from "react-redux";

export default function CreateOrganizationModal({
    data,
}: ThirdPartyConfigureType) {
    const { t } = useTranslation();
    const { userID, operatorID, franchiseID, oneShop } = useSnapshot(store);
    const { shopsThirdPartyData } = useSnapshot(thirdPartyStore);
    const uuidUser = localStorage.getItem("uuidUser");

    const entityDetails = useSelector(
        (state: any) => state.global.entityDetails
    );
    let selectedShop = shopsThirdPartyData.find(
        (el: any) => el.shopId === data.rowData.shopId
    );
    const [organizationId, setOrganizationId] = React.useState<string>(
        data.rowData.organization.organization_id ?? ""
    );
    const [inputOrganizationId, setInputOrganizationId] = React.useState<
        boolean
    >(false);
    const [inputActivityType, setInputActivityType] = React.useState<boolean>(
        false
    );
    const [organizationName, setOrganizationName] = React.useState<string>(
        data.rowData.organization?.info?.name === "" ||
            data.rowData.organization?.info?.name === undefined
            ? oneShop
                ? localStorage.getItem("selectedAccount")
                : selectedShop[t("Shop")]
            : data.rowData.organization.info.name
    );
    const [code, setCode] = React.useState<any>(
        data.rowData.organization?.info?.point_of_contact?.phone_details
            ?.country_code ?? ""
    );
    const [inputOrganizationName, setInputOrganizationName] = React.useState<
        boolean
    >(false);
    const [activityType, setActivityType] = React.useState<string>(
        data.rowData.organization?.info?.merchant_type ?? ""
    );
    const [firstName, setFirstName] = React.useState<string>(
        data.rowData.organization?.info?.point_of_contact?.firstName ?? ""
    );
    const [inputFirstName, setInputFirstName] = React.useState<boolean>(false);
    const [lastName, setLastName] = React.useState<string>(
        data.rowData.organization?.info?.point_of_contact?.lastName ?? ""
    );
    const [inputLastName, setInputLastName] = React.useState<boolean>(false);
    const [email, setEmail] = React.useState<string>(
        data.rowData.organization?.info?.point_of_contact?.email ?? ""
    );
    const [inputEmail, setInputEmail] = React.useState<boolean>(false);
    const [phoneNumber, setPhoneNumber] = React.useState<string>(
        data.rowData.organization?.info?.point_of_contact?.phone_details
            ?.country_code
            ? `${data.rowData.organization?.info?.point_of_contact?.phone_details?.country_code}${data.rowData.organization?.info?.point_of_contact?.phone_details?.subscriber_number}`
            : ""
    );
    const [inputPhoneNumber, setInputPhoneNumber] = React.useState<boolean>(
        false
    );
    const [address, setAddress] = React.useState<string>(
        data.rowData.organization?.info?.address?.street1 ?? ""
    );
    const [inputAddress, setInputAddress] = React.useState<boolean>(false);
    const [postalCode, setPostalCode] = React.useState<string>(
        data.rowData.organization?.info?.address?.zipcode ?? ""
    );
    const [inputPostalCode, setInputPostalCode] = React.useState<boolean>(
        false
    );
    const [city, setCity] = React.useState<string>(
        data.rowData.organization?.info?.address?.state ?? ""
    );
    const [inputCity, setInputCity] = React.useState<boolean>(false);
    const [country, setCountry] = React.useState<string>(
        oneShop ? entityDetails?.Pays : selectedShop[t("Country")]
    );
    const [isoCode, setIsoCode] = React.useState<any>(
        data.rowData.organization?.info?.address?.country_iso2 ?? ""
    );
    function getCountries() {
        fetch(`${process.env.REACT_APP_API_V2_URL}/settings/pays`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        })
            .then((response: any) => response.json())
            .then((response: any) => {
                if (response.data.length > 0) {
                    const selectedCountryCode = response.data.find(
                        (data: any) =>
                            data.Designation.toLowerCase() ===
                            country.toLowerCase()
                    );
                    if (isoCode === "") {
                        setIsoCode(selectedCountryCode.code);
                    }

                    localStorage.setItem(
                        "selectedCountryCode",
                        selectedCountryCode.code.toLowerCase()
                    );
                }
            })
            .catch((error: any) => {
                console.error(
                    "There was an error: getListePays!",
                    error.message
                );
            });
    }

    async function AddOrganization() {
        toast.dismiss();

        if (organizationName === "") {
            setInputOrganizationName(true);
        }
        if (firstName === "") {
            setInputFirstName(true);
        }
        if (lastName === "") {
            setInputLastName(true);
        }
        if (email === "") {
            setInputEmail(true);
        }
        if (phoneNumber === "") {
            setInputPhoneNumber(true);
        }
        if (address === "") {
            setInputAddress(true);
        }
        if (postalCode === "") {
            setInputPostalCode(true);
        }
        if (city === "") {
            setInputCity(true);
        }
        if (activityType === "") {
            setInputActivityType(true);
        }
        if (
            organizationName !== "" &&
            firstName !== "" &&
            lastName !== "" &&
            email !== "" &&
            phoneNumber !== "" &&
            address !== "" &&
            postalCode !== "" &&
            city !== "" &&
            email.match(emailMatchWord) &&
            activityType !== ""
        ) {
            let organization = {
                info: {
                    billing_type: "BILLING_TYPE_DECENTRALIZED",
                    name: organizationName,
                    merchant_type: activityType,
                    point_of_contact: {
                        email: email,
                        phone_details: {
                            phone_number: phoneNumber,
                            country_code: code,
                            subscriber_number: phoneNumber.slice(code.length),
                        },
                        first_name: firstName,
                        last_name: lastName,
                    },
                    address: {
                        street1: address,
                        street2: "",
                        city: country,
                        state: city,
                        zipcode: postalCode,
                        country_iso2: isoCode,
                    },
                },
                hierarchy_info: {
                    parent_organization_id: `${process.env.REACT_APP_PARENT_ORGANIZATION_ID}`,
                },
                options: {
                    onboarding_invite_type: "ONBOARDING_INVITE_TYPE_EMAIL",
                },
            };
            let dataThirdParty = CreateDataThirdParty(
                false,
                false,
                data.rowData.shopId,
                data.rowData.isActive,
                data.rowData.isFavorite,
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                data.rowData.Id,
                data.rowData[t("Third party")],
                data.rowData.ip,
                data.rowData.portApi,
                data.rowData.salesId,
                data.rowData.menusId,
                data.rowData.baseUrl,
                data.rowData.remark,
                false,
                data.rowData.apiKey,
                organization,
                []
            );

            const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/thirdParty`;
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify([
                    { ...dataThirdParty, organization: true },
                ]),
            };

            try {
                const result = await fetchGlobal<any>(
                    apiUrlAdd,
                    requestOptions
                );
                if (result.error) {
                    throw Error("error");
                }
                toast.success(
                    `${t("The organization was created successfully.")!}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        theme: "colored",
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    }
                );
                data.setIsModalOpened(false);
                setShopDataIsUpdated(true);
                setIsEdited(false);
                setIsEdited(false);
                setIsLoading(false);
                mutate(apiUrlAdd, result);
            } catch (e) {
                toast.error(
                    `${t(
                        "Attention, please check the configuration or try again later"
                    )!}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    }
                );
                setIsLoading(false);
            }
        }
    }
    React.useEffect(() => {
        getCountries();
        // eslint-disable-next-line
    }, []);

    return (
        <React.Fragment>
            <Modal
                centered
                isOpen={data.isModalOpened}
                className="information_fidelity_modal__clz mt-5"
            >
                <AvForm className="card information_fidelity__clz">
                    <CustomCardHeader className="d-flex align-items-center justify-content-between">
                        <h5 className="pt-3">
                            {capitalize(
                                t(
                                    data.isConsult
                                        ? "Consult organization"
                                        : "Create organization"
                                )
                            )}
                        </h5>
                        <CrossIcon
                            className="icon-close-notification__clz"
                            height={13}
                            width={13}
                            onClick={() => {
                                data.setIsModalOpened(false);
                            }}
                        />
                    </CustomCardHeader>
                    <CreateOrganizationBody
                        data={{
                            isoCode,
                            setCode: setCode,
                            editedData: data.rowData,
                            organizationName,
                            setOrganizationName,
                            inputOrganizationName,
                            setInputOrganizationName,
                            activityType,
                            setActivityType,
                            firstName,
                            setFirstName,
                            inputFirstName,
                            setInputFirstName,
                            lastName,
                            setLastName,
                            inputLastName,
                            setInputLastName,
                            email,
                            setEmail,
                            inputEmail,
                            setInputEmail,
                            phoneNumber,
                            setPhoneNumber,
                            inputPhoneNumber,
                            setInputPhoneNumber,
                            address,
                            setAddress,
                            inputAddress,
                            setInputAddress,
                            postalCode,
                            setPostalCode,
                            inputPostalCode,
                            setInputPostalCode,
                            city,
                            setCity,
                            inputCity,
                            setInputCity,
                            country,
                            setCountry,
                            organizationId,
                            setOrganizationId,
                            inputOrganizationId,
                            setInputOrganizationId,
                            inputActivityType,
                            setInputActivityType,
                            isConsult: data.isConsult,
                            isConfig: true,
                        }}
                    />
                    <CustomCardFooter className="pt-1 pb-2 mt-4">
                        {!data.isConsult ? (
                            <CustomSecondaryColorButton
                                outline
                                rounded
                                className="mr-2 fed_btn_FRcancel cmn_btn_cancel"
                                variant="light"
                                onClick={() => {
                                    data.setIsModalOpened(false);
                                    setIsEdited(false);
                                }}
                            >
                                <span> {t("Cancel")}</span>
                            </CustomSecondaryColorButton>
                        ) : null}
                        <CustomMainColorButton
                            variant="primary"
                            onClick={() => {
                                data.isConsult
                                    ? data.setIsModalOpened(false)
                                    : AddOrganization();
                                setIsEdited(false);
                            }}
                            rounded
                        >
                            {t(data.isConsult ? "Close" : "Validate")}
                        </CustomMainColorButton>
                    </CustomCardFooter>
                </AvForm>
            </Modal>
        </React.Fragment>
    );
}
